import { ElementRef, Injectable, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { HaloTipsOption } from './halo-tips.model';

@Injectable({
  providedIn: 'root',
})
export class HaloTipsService {
  private active: boolean = false;
  private option: HaloTipsOption[] = [];
  private _firstOption = new Subject<HaloTipsOption | undefined | null>();
  public firstOptionSource = this._firstOption.asObservable();

  private _count = new Subject<number>();
  public countSource = this._count.asObservable();

  constructor() {
    this._firstOption.next(null);
    this._count.next(0);
  }

  add(option: HaloTipsOption[]) {

    this.option = [];
    let _option: HaloTipsOption[] = [];
    option.forEach((item) => {
      const elem = <HTMLElement>document.querySelector(`[data-halo-tips="${item.key}"]`);
      if (elem) {
        // add indicator
        elem.setAttribute('data-halo-tips-indicate', '');

        if (elem.classList.contains('halo-tips-indicate--right')) {
          item.position = 'right';
        } else if (elem.classList.contains('halo-tips-indicate--pos-left')) {
          item.position = 'left';
        }

        // positioning
        // let offset = this.getOffset(elem);
        // _option.push({ ...item, ...offset });
        _option.push(item);
      }
    });

    this.option = JSON.parse(JSON.stringify(_option)) as HaloTipsOption[];
    this._count.next(this.option.length);
    this.publish(false);
  }

  private publish(isOnDismissed: boolean) {
    if (this.option.length > 0 && !this.active) {
      this.show();
    } else {
      if (isOnDismissed) {
        this._firstOption.next(null);
      }
    }
  }

  onDismissed(skip: boolean = false) {
    if(!this.active) return;

    const elem = <HTMLElement>document.querySelector(`[data-halo-tips="${this.option[0].key}"]`);
    elem?.removeAttribute('data-halo-tips-indicate');
    this.active = false;

    if (skip) {
      this._firstOption.next(null);
      this.option.length = 0;

      // remove all indicators
      document.querySelectorAll(`[data-halo-tips-indicate]`).forEach((e) => {
        e.removeAttribute('data-halo-tips-indicate');
      });
    } else {
      this.option.splice(0, 1);
      this.publish(true);
    }
  }

  // close() {
  //   this.onDismissed();
  // }

  private show() {
    // calculation should come here.
    let first = this.option[0];
    const elem = <HTMLElement>document.querySelector(`[data-halo-tips="${first.key}"]`);
    let offset = this.getOffset(elem, first);

    // scroll
    let positionY = window.innerHeight * 2 / 3
    if (offset.top > positionY) {
      const main = <HTMLElement>document.getElementById(`page-cntr`);
      main.scroll(0, (offset.top - positionY) + main.scrollTop);
      offset.top = offset.top - (offset.top - positionY);
    }

    this.active = true;
    this._firstOption.next({ ...first, ...offset });
  }

  async updatePreference() {}

  getOffset(el: HTMLElement, option: HaloTipsOption) {
    const rect = el.getBoundingClientRect();

    const { left, top, width, height } = {
      left: Math.round(rect.left + window.scrollX),
      top: Math.round(rect.top + window.scrollY),
      width: Math.round(el.offsetWidth),
      height: Math.round(el.offsetHeight),
    };
    let calcTop = top;
    let calculatedLeft = left + width / 2 - 13.5;
    let pointLeft = 0;

    if (option.position == 'left') {
      calculatedLeft = left - width;
    } else {
      if (option.position == 'right') {
        calculatedLeft = Math.round(rect.right);
      } 
  
      if (calculatedLeft + 380 > window.innerWidth) {
        pointLeft = (calculatedLeft + 397) - window.innerWidth; //  + width / 2
        calculatedLeft = window.innerWidth - 400;
      }
  
      if(option.pointerPosition != 'bottom'){
        calcTop = top + height + 20;
      }
    }

    return {
      left: calculatedLeft,
      top: calcTop,
      width: width,
      height: height,
      pointLeft: pointLeft,
    };
  }
}

/*
  bottom: 65
  height: 50
  left: 731.9375
  right: 942.8541717529297
  top: 15
  width: 210.9166717529297
  x: 731.9375
  y: 15
*/

// x = left + width/2
// y = top + height